package com.dignicate.web.ui.screens

import androidx.compose.runtime.*
import com.dignicate.web.css.BoxSizing
import com.dignicate.web.css.ColorValue
import com.dignicate.web.css.TextAlign
import com.dignicate.web.css.ThemeVar
import com.dignicate.web.css.boxSizing
import com.dignicate.web.css.color
import com.dignicate.web.css.textAlign
import com.dignicate.web.viewmodels.MainViewModel
import org.jetbrains.compose.web.css.AlignItems
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.JustifyContent
import org.jetbrains.compose.web.css.alignItems
import org.jetbrains.compose.web.css.display
import org.jetbrains.compose.web.css.em
import org.jetbrains.compose.web.css.fontSize
import org.jetbrains.compose.web.css.fontWeight
import org.jetbrains.compose.web.css.justifyContent
import org.jetbrains.compose.web.css.margin
import org.jetbrains.compose.web.css.marginBottom
import org.jetbrains.compose.web.css.marginTop
import org.jetbrains.compose.web.css.maxWidth
import org.jetbrains.compose.web.css.minHeight
import org.jetbrains.compose.web.css.padding
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.vh
import org.jetbrains.compose.web.dom.*

@Composable
fun CompanyPage(viewModel: MainViewModel) {
    val uiState by viewModel.uiState.collectAsState()
    val company = uiState.company

    Div({
        style {
            display(DisplayStyle.Flex)
            alignItems(AlignItems.Center)
            justifyContent(JustifyContent.Center)
            minHeight(60.vh)
            padding(40.px)
            boxSizing(BoxSizing.BorderBox)
        }
    }) {
        Div({ style { maxWidth(800.px); textAlign(TextAlign.Center) } }) {
            H1 { Text("Company") }
            if (company == null) {
                P({ style { marginTop(16.px); color(ColorValue.Var(ThemeVar.Muted)) } }) { Text("Loading...") }
            } else {
                P({ style { marginTop(16.px); color(ColorValue.Var(ThemeVar.Muted)) } }) { Text(company.companyName) }
                Div({ style { textAlign(TextAlign.Left); marginTop(16.px) } }) {
                    company.items.forEach { item ->
                        Div({ style { marginBottom(12.px) } }) {
                            // label (bold)
                            P({ style { margin(0.px); fontWeight(600) } }) { Text(item.label) }

                            // show sublabel only when present
                            val sublabel = item.sublabel
                            if (!sublabel.isNullOrBlank()) {
                                P({ style { margin(4.px, 0.px, 0.px, 0.px); color(ColorValue.Var(ThemeVar.Muted)); fontSize(0.95.em) } }) {
                                    Text(sublabel)
                                }
                            }

                            // value
                            P({ style { margin(4.px, 0.px, 0.px, 0.px); color(ColorValue.Var(ThemeVar.Muted)) } }) { Text(item.value) }
                        }
                    }
                }
            }
        }
    }
}
